/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 Forms = {
    isDisabled: function(form) {
        return form.hasClass('disabled');
    },
    enable: function(form) {
        form.removeClass('disabled');
        form.find('[type="submit"]').prop('disabled', false);
    },
    disable: function(form) {
        form.addClass('disabled');
        form.find('[type="submit"]').prop('disabled', true);
    },
    init: function() {
    }
};

$(document).ready(function() {
    Forms.init();
});
